import { useState, useMemo } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { FiltersCheckBox } from "./FiltersCheckBox";
import SearchIcon from "../../../icons/Search.svg";
import { translate } from "../../../utils/translator";

type Props = {
    filterOptions: { value: string, isSelected: boolean, name: string, keyWordTitle: string }[];
    handleChooseFilter: (item: { value: string, isSelected: boolean }, isMultiSelect?: boolean) => () => void;
    defaultOpen?: boolean;
}

export const MedicalEffectsFilter: React.FC<Props> = ({ filterOptions, handleChooseFilter, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const [searchTerm, setSearchTerm] = useState("");
    const language = localStorage.getItem("language") || "de";

    const visibleOptions = useMemo(() => {
        if (!searchTerm.trim()) return filterOptions;
        const term = searchTerm.toLowerCase();
        return filterOptions.filter(opt => opt.name.toLowerCase().includes(term));
    }, [filterOptions, searchTerm]);

    return (
        <div className="pt-2 pb-4 md:pt-4">
            <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="text-md font-medium capitalize my-3">
                    {filterOptions[0]?.keyWordTitle}
                </div>
                <div className="flex">
                    {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
            </div>

            <div
                className="grid transition-all duration-500 ease-in-out"
                style={{
                    overflow: 'hidden',
                    gridTemplateRows: isOpen ? '1fr' : '0fr',
                }}
            >
                <div className="overflow-hidden">
                    {/* Search bar */}
                    <div
                        className="flex items-center gap-3 px-4 rounded-[4px] h-[46px] mb-3"
                        style={{ border: "1px solid #DBE1EB" }}
                    >
                        <img src={SearchIcon} alt="" className="w-[21px] h-[21px]" />
                        <input
                            type="text"
                            placeholder={translate(language, 'choose_treatment', 'default/searching_for_impact') || "Suche nach Wirkung"}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            className="w-full text-[16px] placeholder-[#98A0AF]"
                            style={{ border: 'none', outline: 'none', background: 'transparent' }}
                        />
                    </div>

                    {/* Checkbox list */}
                    <div className="max-h-[250px] overflow-y-auto">
                        {visibleOptions.map((item) => (
                            <div
                                key={item.value}
                                className="
                                    flex items-center gap-3 py-[10px] px-1 cursor-pointer
                                    border-b border-[#f9f8f6] last:border-b-0
                                "
                                onClick={() => handleChooseFilter(item)()}
                            >
                                <FiltersCheckBox isSelected={item.isSelected} />
                                <span className="text-[16px] font-medium">
                                    {item.name}
                                </span>
                            </div>
                        ))}

                        {visibleOptions.length === 0 && searchTerm && (
                            <div className="py-3 text-[14px] text-[#98A0AF] text-center">
                                {translate(language, 'choose_treatment', 'default/no_results') || "keine Ergebnisse"}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
